export default __webpack_public_path__ + "static/media/logoAu.ca8bc460.png";